module.exports = __webpack_public_path__ + "media/images/payments/visa-dark-3d222577b8647b41000999248827d79a.svg";